<template>
    <div class="apaasCloudAdvantage introduce-container">
        <h3 class="apaasCloud-title">全新一代低代码产品能力</h3>
        <p class="apaasCloud-subtitle">兼容专属定制和灵活搭建，更从容适配个性化业务需求</p>
        <ul class="apaasCloudAdvantage-tab">
            <li :ref="'advantage'+index" v-for="(item, index) in advantageList" :key="item.name" @click="changeActive(activeCarouselIndex, index)" :class="{'carousel-name':true, 'carousel-name-active': index === activeCarouselIndex}">
                {{item.name}}
            </li>
            <span class="apaasCloudAdvantage-tab-bottom" :style="activeBottomStyle"></span>
        </ul>
        <Carousel v-model="activeCarouselIndex" loop autoplay :autoplay-speed="5000" dots="none" class="apaasCloudAdvantage-carousel" arrow="always">
            <CarouselItem v-for="item in advantageList" :key="item.name" @change="changeActive(oldV, newV)">
                <img :src="item.img" />
                <div class="carousel-desc">{{item.desc}}</div>
            </CarouselItem>
        </Carousel>
        <p class="apaasCloud-subtitle" style="color: #666;margin: 0;">{{activeAdvantageDesc}}</p>
    </div>
</template>

<script>
    export default {
        name: "apaasCloudAdvantage",
        components: {},
        data () {
            return {
                activeCarouselIndex: 0,
                activeBottomStyle: {
                    left: "215px"
                },
                advantageList: [
                    {name: "灵活表单", img: this.$imageSrcMap.introduction.apaas.form, desc: "多种字段类型，简单拖拽即可搭建，还可设置数据联动计算及多种公式函数"},
                    {name: "流程引擎", img: this.$imageSrcMap.introduction.apaas.flow, desc: "通过可视化的流程编辑页面，灵活设计流程流转规则"},
                    {name: "自定义可视化", img: this.$imageSrcMap.introduction.apaas.customShow, desc: "将数据通过饼图、柱状图、甘特图等形式展示，从而实现数据的统计、分析、对比"},
                    {name: "统一资源库", img: this.$imageSrcMap.introduction.apaas.resource, desc: "将通用性、规范性数据通过资源库的形式存储，从而实现一次录入、多处使用"},
                    {name: "知识管理", img: this.$imageSrcMap.introduction.apaas.knowledge, desc: "将放置不同位置的“附件”通过文件夹归类方式进行统一管理"},
                    {name: "自定义页面", img: this.$imageSrcMap.introduction.apaas.customPage, desc: "自定义不同展示形式和操作路径，同时兼容其他页面嵌入，无缝衔接"},
                    {name: "灵活权限", img: this.$imageSrcMap.introduction.apaas.authority, desc: "可分角色/业务/场景等灵活自定义各维度权限并实现精细化操作"},
                    {name: "代码块", img: this.$imageSrcMap.introduction.apaas.api, desc: "输入简单代码，满足任何复杂业务场景"}
                ]
            };
        },
        created () {
            this.getBottomStyle();
        },
        computed: {
            activeAdvantageDesc () {
                return this.advantageList.find((item, index) => index === this.activeCarouselIndex).desc;
            }
        },
        watch: {
            activeCarouselIndex (val) {
                this.getBottomStyle();
            }
        },
        methods: {
            changeActive (oldV, newV) {
                this.activeCarouselIndex = newV;
            },
            getBottomStyle () {
                let dom = null;
                this.$nextTick(() => {
                    dom = this.$refs["advantage" + this.activeCarouselIndex] && this.$refs["advantage" + this.activeCarouselIndex][0];
                    if (!dom) {
                        this.activeBottomStyle = {};
                        return;
                    }
                    let activeBottomStyle = {
                        left: dom.offsetLeft + (dom.offsetWidth / 2) - 13 + "px"
                    };
                    this.activeBottomStyle = activeBottomStyle;
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/introduction/apaasCloud/apaasCloudAdvantage.vue